var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedicalCronologyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2787_3518",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2787_3518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66659 14.6666C2.29992 14.6666 1.98603 14.5361 1.72492 14.275C1.46381 14.0139 1.33325 13.7 1.33325 13.3333V5.33331C1.33325 4.96665 1.46381 4.65276 1.72492 4.39165C1.98603 4.13054 2.29992 3.99998 2.66659 3.99998H5.33325V2.66665C5.33325 2.29998 5.46381 1.98609 5.72492 1.72498C5.98603 1.46387 6.29992 1.33331 6.66659 1.33331H9.33325C9.69992 1.33331 10.0138 1.46387 10.2749 1.72498C10.536 1.98609 10.6666 2.29998 10.6666 2.66665V3.99998H13.3333C13.6999 3.99998 14.0138 4.13054 14.2749 4.39165C14.536 4.65276 14.6666 4.96665 14.6666 5.33331V13.3333C14.6666 13.7 14.536 14.0139 14.2749 14.275C14.0138 14.5361 13.6999 14.6666 13.3333 14.6666H2.66659ZM2.66659 13.3333H13.3333V5.33331H2.66659V13.3333ZM6.66659 3.99998H9.33325V2.66665H6.66659V3.99998ZM7.33325 9.99998V12H8.66659V9.99998H10.6666V8.66665H8.66659V6.66665H7.33325V8.66665H5.33325V9.99998H7.33325Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalCronologyIcon);
export default __webpack_public_path__ + "static/media/MedicalCronologyIcon.fd37ccaffdf90a78c85308907f15b428.svg";
export { ForwardRef as ReactComponent };